import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/SeatLayout.scss";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axios";
import CustomerSeatLayout from "../components/CustomerSeatLayout";
import { AuthContext } from "../contexts/AuthContext";

const BookSeatsPage = () => {
  const location = useLocation();
  const {
    theatre_id,
    screen_id,
    date_id,
    slot_id,
    pk,
    movie_id,
    name,
    slot_name,
    screen_name,
    theatre_name,
  } = location.state || {};

  const [selectedSeats, setSelectedSeats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [screen, setScreen] = useState({});
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  useEffect(() => {
    fetchSeatLayout();
  }, [screen_id, slot_id, pk]);

  const fetchSeatLayout = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(
        `booking/screen/${pk}/theatre/${theatre_id}/screen/${screen_id}/date/${date_id}/slot/${slot_id}/`
      );
      setScreen({
        sections: data?.screen?.sections || [],
        bookedSeats: data?.bookedSeats || []
      });
    } catch (err) {
      toast.error("Cannot fetch seat layout");
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (seat) => {
    setSelectedSeats((prev) => {
      const found = prev.includes(seat.id);
      return found ? prev.filter((id) => id !== seat.id) : [...prev, seat.id];
    });
  };

  const totalPrice = selectedSeats.reduce((sum, seatId) => {
    let finalPrice = 0;
    let sectionPrice = 0;

    for (const section of screen.sections || []) {
      for (const section of screen.sections || []) {
        for (const block of section.blocks || []) {
          for (const row of block.rows || []) {
            const seat = row.seats?.find((s) => s.id === seatId);

            if (seat) {
              const seatTypePrice = parseFloat(seat?.seat_type?.price || 0);
              const rowPrice = parseFloat(row?.price || 0);
              const sectionPrice = parseFloat(section?.price || 0);

              if (seat?.seat_type?.name == "Disabled" && seatTypePrice > 0) {
                finalPrice = seatTypePrice;
              } else {
                finalPrice = rowPrice > 0 ? rowPrice : sectionPrice;
              }

              break;
            }
          }
          if (finalPrice) break;
        }
        if (finalPrice) break;
      }
      if (finalPrice) break;
    }

    return sum + finalPrice;
  }, 0);


  const handlePayment = async () => {

    const isLoggedIn = user.isAuthenticated;

    // console.log(location)

    if (!isLoggedIn) {
      navigate("/signin", { state: { from: location.pathname, state: location.state } });
      return;
    }
    if (selectedSeats.length === 0) {
      toast.error("Select at least one seat");
      return;
    }

    const paymentData = {
      show: pk,
      show_date: date_id,
      show_time_slot: slot_id,
      number_of_seats: selectedSeats.length,
      seats: selectedSeats,
      amount_to_pay: (
        totalPrice
      ).toFixed(2),
    };

    try {
      const response = await axiosInstance.post('/booking/place-order', paymentData);
      console.log(response);

      if (response.data?.client_secret) {
        console.log(response);
        toast.success("Seat reserved. Redirecting to payment...");

        // redirect with clientSecret + booking ID
        navigate("/stripe-payment", {
          state: {
            clientSecret: response.data.client_secret,
            bookingId: response.data.booking_id,
            amount: totalPrice.toFixed(2),
            movie: name,
            number_of_seats: selectedSeats.length,
            service_charge: response.data.service_charge,
            stripe_fee: response.data.stripe_fee
          },
        });
      } else {
        console.log("else");
        toast.info("ERROR: Could not initiate payment");
      }
    } catch (err) {
      console.log("PAYMENT ERROR:", err?.response?.data);

      const backendMessage =
        err?.response?.data?.message?.[0] ||
        err?.response?.data?.message ||
        "Failed to reserve seats";
      console.log(backendMessage);

      toast.error(backendMessage);
    }

  };

  return (
    <div className="container py-4">
      <h5>{name}</h5>
      <p className="text-muted">
        <strong>{theatre_name} | {screen_name}</strong> | {slot_name}
      </p>



      <div className="screen-indicator">
        <div className="screen-bar" />
        <div className="screen-text">All eyes this way please!</div>
      </div>

      <CustomerSeatLayout
        sections={screen.sections || []}
        selected={selectedSeats}
        bookedSeats={screen.bookedSeats || []}
        onToggle={handleToggle}
      />


      <div className="seat-legend">
        <div className="legend-box">
          <div className="legend available" /> Available
        </div>
        <div className="legend-box">
          <div className="legend selected" /> Selected
        </div>
        <div className="legend-box">
          <div className="legend booked" /> Disabled / Booked
        </div>
        <div className="legend-box">
          <div className="legend double-seat" /> Couple Seat
        </div>
        <div className="legend-box">
          🦽 Wheelchair space
        </div>
        <div className="legend-box">
          <div className="legend available" style={{ marginRight: 0 }} />
          <div className="legend available" style={{ marginLeft: 0 }} /> Double Seat
        </div>
      </div>

      {selectedSeats.length > 0 && (
        <div className="floating-pay">
          {/* <p>Selected Seats: {selectedSeats.join(", ")}</p> */}
          <button className="btn btn-primary" onClick={handlePayment} >Pay EUR {totalPrice.toFixed(2)}</button>
        </div>
      )}
    </div>
  );
};

export default BookSeatsPage;
